module.exports = __webpack_public_path__ + "static/media/Comedy.3e089129.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/UI/musicButton/song/Comedy.mp3
// module id = 936
// module chunks = 0